"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    DropdownType: function() {
        return DropdownType;
    },
    Dropdown: function() {
        return Dropdown;
    }
});
var _react = /*#__PURE__*/ _interopRequireWildcard(require("react"));
var _react1 = require("@headlessui/react");
var _classnames = /*#__PURE__*/ _interopRequireDefault(require("classnames"));
var _solid = require("@heroicons/react/solid");
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
var DropdownType;
(function(DropdownType) {
    DropdownType["PRIMARY"] = "primary";
    DropdownType["SECONDARY"] = "secondary";
})(DropdownType || (DropdownType = {}));
var Dropdown = function(param) {
    var className = param.className, _param_variant = param.variant, variant = _param_variant === void 0 ? DropdownType.PRIMARY : _param_variant, options = param.options, selected = param.selected, onChange = param.onChange, renderMenuButton = param.renderMenuButton;
    var _options_find;
    var currentLabel = (_options_find = options.find(function(option) {
        return option.value === (selected === null || selected === void 0 ? void 0 : selected.value);
    })) === null || _options_find === void 0 ? void 0 : _options_find.label;
    var classes = {
        menuBtn: (0, _classnames.default)({
            "inline-flex justify-between w-full px-4 py-2 text-sm font-medium transition": true,
            "rounded-md border border-gray-300 bg-white text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100 focus:ring-accent-500": variant === DropdownType.PRIMARY,
            "text-accent-600 hover:text-accent-500": variant === DropdownType.SECONDARY
        })
    };
    return /*#__PURE__*/ _react.default.createElement(_react1.Menu, {
        as: "div",
        className: (0, _classnames.default)("relative inline-block text-left", _defineProperty({}, className || "", className))
    }, function(param) {
        var open = param.open;
        /*#__PURE__*/ return _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement("div", null, /*#__PURE__*/ _react.default.createElement(_react1.Menu.Button, {
            className: classes.menuBtn
        }, renderMenuButton ? renderMenuButton(selected) : currentLabel, open ? /*#__PURE__*/ _react.default.createElement(_solid.ChevronUpIcon, {
            className: "-mr-1 ml-2 h-5 w-5",
            "aria-hidden": "true"
        }) : /*#__PURE__*/ _react.default.createElement(_solid.ChevronDownIcon, {
            className: "-mr-1 ml-2 h-5 w-5",
            "aria-hidden": "true"
        }))), /*#__PURE__*/ _react.default.createElement(_react1.Transition, {
            as: _react.Fragment,
            enter: "transition ease-out duration-100",
            enterFrom: "transform opacity-0 scale-95",
            enterTo: "transform opacity-100 scale-100",
            leave: "transition ease-in duration-75",
            leaveFrom: "transform opacity-100 scale-100",
            leaveTo: "transform opacity-0 scale-95"
        }, /*#__PURE__*/ _react.default.createElement(_react1.Menu.Items, {
            className: "origin-top-right absolute right-0 mt-2 w-full lg:w-56 md:w-56 rounded-md bg-white ring-1 ring-black ring-opacity-5 focus:outline-none z-10"
        }, /*#__PURE__*/ _react.default.createElement("div", {
            className: "py-1"
        }, options.map(function(option) {
            /*#__PURE__*/ return _react.default.createElement(_react1.Menu.Item, {
                key: option.value,
                disabled: option.disabled
            }, function(param) {
                var active = param.active;
                /*#__PURE__*/ return _react.default.createElement("div", {
                    onClick: function() {
                        return onChange && onChange(option);
                    },
                    className: (0, _classnames.default)("block px-4 py-2 text-sm", {
                        "bg-gray-100 text-gray-900": active,
                        "text-gray-700": !active,
                        "cursor-pointer": !(option === null || option === void 0 ? void 0 : option.disabled),
                        "text-opacity-50 cursor-default": option === null || option === void 0 ? void 0 : option.disabled,
                        "border-t border-gray-900 hover:bg-white": !option.label
                    })
                }, option.label);
            });
        })))));
    });
};

//# sourceMappingURL=Dropdown.js.map